import { render, staticRenderFns } from "./DLBudget.vue?vue&type=template&id=3b39815a&scoped=true&"
import script from "./DLBudget.vue?vue&type=script&lang=js&"
export * from "./DLBudget.vue?vue&type=script&lang=js&"
import style0 from "./DLBudget.vue?vue&type=style&index=0&id=3b39815a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39815a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
